import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "../../ui/dist/taskguard-ui.css";
import { App } from "./app";

async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  try {
    await navigator.serviceWorker.register("./sw.js");
    let didReloadForServiceWorker = false;

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (didReloadForServiceWorker) {
        return;
      }

      didReloadForServiceWorker = true;
      window.location.reload();
    });
  } catch (error) {
    console.warn("Service worker registration failed", error);
  }
}

void registerServiceWorker();

const element = document.getElementById("root");

if (element == null) {
  throw new Error("Missing root element");
}

const app = (
  <StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </StrictMode>
);

if (import.meta.hot) {
  const hotData = import.meta.hot.data as { root?: ReturnType<typeof createRoot> };
  const root = hotData.root ?? createRoot(element);
  hotData.root = root;
  root.render(app);
} else {
  createRoot(element).render(app);
}
